import { apiRequestRaw, apiRequestWithChecks, fileUpload } from "./api";


export const file = {

    uploadVoiceFile: function (token, file) {
        return apiRequestRaw("POST", "/api/file/voice-file?mimeType=" + encodeURIComponent(file.type || "audio/wav"), {
            "Authorization": "Bearer " + token,
            "X-FILENAME": encodeURIComponent(file.name)
        }, file);
    },

    uploadRecording: function (token, audioBlob, mimeType) {
        return apiRequestRaw("POST", "/api/file/recording?mimeType=" + encodeURIComponent(mimeType), {
            "Authorization": "Bearer " + token
        }, audioBlob);
    },

    uploadTemplateRecording: function (token, audioBlob, mimeType) {
        return apiRequestRaw("POST", "/api/file/recording-template?mimeType=" + encodeURIComponent(mimeType), {
            "Authorization": "Bearer " + token
        }, audioBlob);
    },

    startTemplateRecordingCall: function (token, request) {
        return apiRequestWithChecks("POST", "/api/templates/voice/recording/start", {
            "Authorization": "Bearer " + token
        }, request);
    },

    getTemplateRecordingStatus: function (token, sessionId) {
        return apiRequestWithChecks("GET", "/api/templates/voice/recording/status?sessionId=" + encodeURIComponent(sessionId), {
            "Authorization": "Bearer " + token
        });
    },

    sendTemplatePreviewCall: function (token, request) {
        return apiRequestWithChecks("POST", "/api/templates/voice/preview-call", {
            "Authorization": "Bearer " + token
        }, request);
    },

    sendTemplateTtsPreviewCall: function (token, request) {
        return apiRequestWithChecks("POST", "/api/templates/tts-preview-call", {
            "Authorization": "Bearer " + token
        }, request);
    },

    /**
     * Fetches CDYNE-recorded voice audio via the auth proxy and returns a blob:// URL
     * safe to pass directly to an <audio> element or AudioPlayer.
     * @param {string} token
     * @param {string} fileIdOrPath - soundFileId (e.g. keep_xxx) or full proxy path
     * @returns {Promise<string|null>} blob:// URL, or null on failure
     */
    getVoiceAudio: async function (token, fileIdOrPath) {
        if (!fileIdOrPath) return null;
        const url = fileIdOrPath.startsWith("/api/")
            ? fileIdOrPath
            : `/api/templates/voice/audio?fileId=${encodeURIComponent(fileIdOrPath)}`;
        try {
            const resp = await fetch(url, { headers: { "Authorization": "Bearer " + token } });
            if (!resp.ok) return null;
            const blob = await resp.blob();
            return URL.createObjectURL(blob);
        } catch {
            return null;
        }
    },

    textToSpeech: function (token, message) {
        if (!message || !message.trim()) {
            return Promise.resolve({
                success: false,
                errorMessage: "A message is required."
            });
        }

        return apiRequestWithChecks("POST", "/api/file/text-to-speech", {
            "Authorization": "Bearer " + token
        }, { message: message });
    },


    getLibraryItems: function (token) {
        return apiRequestWithChecks("GET", "/api/file/library", {
            "Authorization": "Bearer " + token
        });
    },

    saveLibraryItem: function (token, item) {
        return apiRequestWithChecks("PUT", "/api/file/library", {
            "Authorization": "Bearer " + token
        }, item);
    },

    deleteLibraryItem: function (token, itemId) {
        return apiRequestWithChecks("DELETE", "/api/file/library?itemId=" + itemId, {
            "Authorization": "Bearer " + token
        });
    },

    duplicateLibraryItem: function (token, itemId) {
        return apiRequestWithChecks("DELETE", "/api/file/library/duplicate?itemId=" + itemId, {
            "Authorization": "Bearer " + token
        });
    },

    uploadAttachment: function (token, file, progress_callback, maxFileSizeMB) {
        fileUpload("/api/file/attachment", token, file, progress_callback, maxFileSizeMB);
    },

    shortenUrl: function (token, url) {
        return apiRequestWithChecks("POST", "/api/file/shorten", {
            "Authorization": "Bearer " + token
        }, { url: url });
    },

    uploadBase64Item: function (token, filename, data, tag, overwriteId) {
        return apiRequestWithChecks("POST", "/api/file/base64?tag=" + tag + (overwriteId ? "&overwrite=" + overwriteId : ""), {
            "Authorization": "Bearer " + token,
            "X-FILENAME": encodeURIComponent(filename),
            "Content-Type": "image/png"
        }, data);
    },

    upload: function (url, token, file, progress_callback, maxFileSizeMB) {
        fileUpload(url, token, file, progress_callback, maxFileSizeMB)
    }
}
